import type { RootStore } from "@state/stores/types";
import { StorageStateKeysEnum } from "@utils/storage";
import { action, observable } from "mobx";

class OnboardingNextStore {
	@observable isActive: boolean = false;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	showPopup() {
		this.isActive = true;

		this.rootStore.localStorageProvider.set(
			StorageStateKeysEnum.ONBOARDING_NEXT_POPUP,
			JSON.stringify(true)
		);
	}

	@action.bound
	hidePopup() {
		this.isActive = false;
	}

	@action.bound
	redirectToNextPage() {
		this.hidePopup();

		window.open("https://next.tipwin.de/", "_blank");
	}

	@action.bound
	onDispose() {
		this.isActive = false;
	}
}

export default OnboardingNextStore;
